var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"flex-grow-0",class:_vm.widthClass,attrs:{"value":_vm.value,"label":_vm.label,"suffix":_vm.suffix,"disabled":_vm.disabled,"min":_vm.min,"step":_vm.step,"rules":_vm.rules,"type":"number","dense":"","outlined":"","hide-spin-buttons":"","hide-details":"auto"},on:{"input":function($event){return _vm.emit($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }